import { render } from "./SubButton.vue?vue&type=template&id=b263f7dc&scoped=true"
import script from "./SubButton.vue?vue&type=script&lang=js"
export * from "./SubButton.vue?vue&type=script&lang=js"

import "./SubButton.vue?vue&type=style&index=0&id=b263f7dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b263f7dc"]])

export default __exports__